import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'
import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'
import { Table } from 'legacy/lut/library/list'
import { useCallback, useEffect, useMemo, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { deleteParamsFromUrl, getUrlWithParams } from 'core-components/helpers/url'
import { Button } from 'core-components/library/button'
import { LoaderOverlay } from 'core-components/library/loader'
import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { fetchPartners } from '../../../services/fetchPartners'

import { PLANNING_TAB, PLANNING_TAB_URL } from './config'
import { getColumns } from './helpers/getColumns'
import { tr } from './translations'

import styles from './PartnersWithoutSoBDialogContent.module.scss'

interface IProps {
  partnerIds: string
  onClose: () => void
}

export const PartnersWithoutSoBDialogContent = ({ partnerIds, onClose }: IProps) => {
  /** -------------------- State ----------------------- */

  const [foundPartners, setFoundPartners] = useState<IWWPartners[]>([])
  const [isLoaded, setIsLoaded] = useState(true)

  /** -------------------- Methods ----------------------- */

  const refreshPartners = async (partnersIds: string[]) => {
    setIsLoaded(false)

    const partnersResponse = await fetchPartners<IWWPartners>(partnersIds)
    const partners = partnersResponse?.Rows || []
    setFoundPartners(partners)

    setIsLoaded(true)
  }

  /** -------------------- User actions handlers ----------------------- */

  const onOpenPartnerPlan = useCallback((item: IWWPartners) => {
    const partnerId = item.PartnerID

    const linkWithoutDeletedParams = deleteParamsFromUrl(['pid'])
    const url = getUrlWithParams(
      { page: 'jbl-hpscoutso', pid: partnerId, [PLANNING_TAB_URL]: PLANNING_TAB },
      linkWithoutDeletedParams
    )

    window.open(url, '_blank')
  }, [])

  /** -------------------- Effects ----------------------- */

  const partnersCrud = useMemo(() => {
    return new Crud({ fetcher: new Static(foundPartners), keyField: 'PartnerID' })
  }, [foundPartners])

  const editorColumns = useMemo(() => getColumns({ onOpenPartnerPlan }), [onOpenPartnerPlan])

  useEffect(() => {
    setFoundPartners([])

    const partnersIds = (partnerIds || '').split(',').filter((el) => !!el)
    if (partnersIds.length) {
      refreshPartners(partnersIds)
    }
  }, [partnerIds])

  /** -------------------- Render ----------------------- */

  return (
    <div className={styles.root}>
      <WidgetHeader>{tr.title}</WidgetHeader>

      <LoaderOverlay show={!isLoaded} />

      <div className={styles.contentContainer}>
        <Table<IWWPartners>
          pagination
          header
          columns={editorColumns}
          source={partnersCrud}
          hasTranslate
        />
      </div>

      <div className={styles.bottomContainer}>
        <Button onClick={onClose}>
          <Translation text={tr.closeButton} />
        </Button>
      </div>
    </div>
  )
}
